// @ts-check
import useContextActions from '../../../../../useContextActions';
import { LBButton } from '@linearb/buzz';
import Icon from 'components/base/Icon';

const ClearFiltersButton = ({ Context }) => {
  const contextActions = useContextActions({ Context });

  const onClick = () => {
    contextActions.onClearFilterSet();
  };

  return (
    <LBButton
      variant='link'
      size='icon'
      onClick={onClick}
      data-cy='clear-filter-button'
    >
      <Icon name='Close' color='chambray' size='normal' />
    </LBButton>
  );
};

export default ClearFiltersButton;
